import type { Dispatch } from "react"
import type { AsyncError, ErrorContext } from "@/lib/api/errors"
import { toAsyncError } from "@/lib/api/errors"

type BookingAction =
  | { type: "SET_EVENT_ERROR"; error: AsyncError }
  | { type: "SET_OFFERS_ERROR"; error: AsyncError }
  | { type: "SET_FLIGHT_OFFERS_ERROR"; error: AsyncError }
  | { type: "SET_HOTEL_ADDONS_ERROR"; error: AsyncError }
  | { type: "SET_BOOKING_ERROR"; error: AsyncError | null }

export function dispatchApiError(
  dispatch: Dispatch<BookingAction>,
  error: unknown,
  context: ErrorContext
) {
  const asyncError = toAsyncError(error, context)

  switch (context) {
    case "event":
      dispatch({ type: "SET_EVENT_ERROR", error: asyncError })
      break
    case "offers":
      dispatch({ type: "SET_OFFERS_ERROR", error: asyncError })
      break
    case "flights":
      dispatch({ type: "SET_FLIGHT_OFFERS_ERROR", error: asyncError })
      break
    case "addons":
      dispatch({ type: "SET_HOTEL_ADDONS_ERROR", error: asyncError })
      break
    case "booking":
      dispatch({ type: "SET_BOOKING_ERROR", error: asyncError })
      break
  }
}
